// modules/dashboard/utils/colores.js
// Color ÚNICO por estrategia, el mismo en toda la app (tarjetas del Home,
// dashboard, leyendas). Validado para daltonismo como paleta categórica en
// gráficos de barras/apiladas (orden RBC → Vejez → Hab. Calle → Migrante).
// El color va en las marcas (barras, puntos, bordes); los textos usan
// siempre los colores de texto, nunca el de la serie.

export const ESTRATEGIA_COLOR = {
  rbc: "#0f8a5f",
  vejez: "#2a78d6",
  habitante_calle: "#d9453c",
  migrante: "#7a4fd0",
};

export const ESTRATEGIA_INFO = [
  { clave: "rbc", nombre: "Discapacidad — RBC", corto: "RBC", emoji: "♿", color: ESTRATEGIA_COLOR.rbc },
  { clave: "vejez", nombre: "Vejez", corto: "Vejez", emoji: "🧓", color: ESTRATEGIA_COLOR.vejez },
  { clave: "habitante_calle", nombre: "Habitante de Calle", corto: "Hab. Calle", emoji: "🏙️", color: ESTRATEGIA_COLOR.habitante_calle },
  { clave: "migrante", nombre: "Población Migrante", corto: "Migrante", emoji: "🧭", color: ESTRATEGIA_COLOR.migrante },
];

export const AZUL_INSTITUCIONAL = "#1a3a5c";
export const GRIS_NEUTRO = "#c5cdd8";   // "No" / resto en proporciones
export const GRIS_OSCURO = "#8592a3";   // categorías secundarias (No sabe, Parcialmente…)
export const TEXTO = "#1f2937";
export const TEXTO_2 = "#5b6575";
export const REJILLA = "#edf0f4";
